import { render, staticRenderFns } from "./PreviousStatement.vue?vue&type=template&id=5e90dfc0&"
import script from "./PreviousStatement.vue?vue&type=script&lang=js&"
export * from "./PreviousStatement.vue?vue&type=script&lang=js&"
import style0 from "./PreviousStatement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports